import React from 'react'
import { Dropdown } from 'primereact/dropdown'

/**
 * Programme Type (AV Type) filter template that filters by iconId
 * Shows icon descriptions (Radio, Film, TV) rather than programme type names
 * @param {object} options - Filter options from PrimeReact column
 */
const ProgrammeTypeFilterTemplate = ({ options }) => {
    
const dropdownOptions = [
    { label: 'Radio', value: 1 },
    { label: 'Film', value: 2 },
    { label: 'Television', value: 3 }
]

    return (
        <Dropdown
            value={options.value}
            options={dropdownOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Select Type"
            className="p-column-filter"
            showClear
        />
    )
}

export default ProgrammeTypeFilterTemplate

